<template>
  <div color="primary">
    <v-tabs v-model="tab" background-color="secondary" show-arrows grow color="primary">
      <v-tab key="scorm" color="primary">
        <v-icon class="mr-2">
          mdi-file-cabinet
        </v-icon>
        Scorm
      </v-tab>

      <v-tab key="videos">
        <v-icon class="mr-2">
          mdi-motion-play-outline
        </v-icon>
        Videos
      </v-tab>

      <v-tab key="images">
        <v-icon class="mr-2">
          mdi-file-image-outline
        </v-icon>
        Images
      </v-tab>

      <v-tab key="reviews">
        <v-icon class="mr-2">
          mdi-message-outline
        </v-icon>
        Reviews
      </v-tab>

    </v-tabs>
    <v-tabs-items v-model="tab" color="primary">
      <v-tab-item key="scorm">
        <Scorm/>
      </v-tab-item>
      <v-tab-item key="videos">
        <Videos/>
      </v-tab-item>
      <v-tab-item key="images">
        <Images/>
      </v-tab-item>
      <v-tab-item key="reviews">
        <Reviews/>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
<script>

import Reviews from "./Reviews";
import Images from "./Images";
import Scorm from "./Scorm";
import Videos from "./Videos";

export default {
  name: "ContentTab",
  components: {Videos, Scorm, Reviews, Images},
  data() {
    return {
      tab: null,
    };
  },
};
</script>